// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.combobox {
    display: inline-flex;
    align-items: center;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
}

div.combobox-button {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    padding: 0.25em 0.125em;
    height: 100%;
}

span.combobox-button-content {
    padding: 0 0.25em;
    flex: 1 1 auto;
    white-space: nowrap;
}

div.combobox-button > span.icon {
    font-size: 100%;
    flex: 0 0 1em;
}

div.combobox-menu {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
}

div.combobox-menu-entry {
    padding: 0.25em;
}

div.combobox-menu-entry:not(.combobox-menu-entry-disabled):hover  {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.combobox-menu-entry-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.combobox-menu-entry-active:hover {
    background-color: var(--list-item-bg-color-active-hover)!important;
    color: var(--list-item-text-color-active-hover)!important;
}

div.combobox-menu-entry-disabled {
    color: var(--text-color-disabled);
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/ComboBox.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,kEAAkE;IAClE,yDAAyD;AAC7D;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":["div.combobox {\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n}\n\ndiv.combobox-button {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    padding: 0.25em 0.125em;\n    height: 100%;\n}\n\nspan.combobox-button-content {\n    padding: 0 0.25em;\n    flex: 1 1 auto;\n    white-space: nowrap;\n}\n\ndiv.combobox-button > span.icon {\n    font-size: 100%;\n    flex: 0 0 1em;\n}\n\ndiv.combobox-menu {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n}\n\ndiv.combobox-menu-entry {\n    padding: 0.25em;\n}\n\ndiv.combobox-menu-entry:not(.combobox-menu-entry-disabled):hover  {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.combobox-menu-entry-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.combobox-menu-entry-active:hover {\n    background-color: var(--list-item-bg-color-active-hover)!important;\n    color: var(--list-item-text-color-active-hover)!important;\n}\n\ndiv.combobox-menu-entry-disabled {\n    color: var(--text-color-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
